module.exports = __webpack_public_path__ + "img/message_icon.c88b4d99.svg";